import React from 'react';
import { useNavigate } from 'react-router-dom';
import { pathFor } from '../components/nav';
import Reveal from '../components/Reveal';
import Icon from '../components/Icon';

// Large uppercase band. `highlight` is the word rendered in the brand green.
export default function CTA({
  title = 'Have a Project, Idea, or Digital Challenge?',
  highlight = 'Project',
  text = 'Let’s build something meaningful together.',
  button = 'Get In Touch',
  to = 'contact',
}) {
  const navigate = useNavigate();
  const at = highlight ? title.indexOf(highlight) : -1;
  return (
    <section className="cta">
      <Reveal className="container cta__inner">
        <h2>
          {at < 0 ? title : (<>{title.slice(0, at)}<em>{highlight}</em>{title.slice(at + highlight.length)}</>)}
        </h2>
        <p>{text}</p>
        <button className="btn btn--primary" onClick={() => navigate(pathFor(to))}>{button} <Icon name="arrow" size={18} /></button>
      </Reveal>
    </section>
  );
}
